import CandidateProfile from "./CandidateProfile";

export { CandidateProfile as default };
